import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  contract: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'lease-contract' }),
}

export { paths }
